import { createFileRoute, redirect } from '@tanstack/react-router'
import { getUser } from '@/utils/auth'
import ZaloUserDomain from '@/components/settings-route/multi-channel/zalo-user/zalo-user-domain'
import { checkAccessViewZaloDomain } from '@/components/settings-route/multi-channel/zalo-user/util'

export const Route = createFileRoute(
  '/_auth/settings/multi-channels/zalo-user/',
)({
  component: ZaloUserWrapper,
  beforeLoad: async () => {
    const user = getUser()

    // need to be user in tenant zenify and super admin
    if (!checkAccessViewZaloDomain(user)) {
      return redirect({
        to: `/settings/multi-channels/zalo-user/${user.tenant_id}`,
      })
    }
  },
})

function ZaloUserWrapper() {
  return <ZaloUserDomain />
}
